<template>
    <div>
        <div class="row center-xy">
            <div class="col-md-10">&nbsp;</div>
            <div class="text-right mb-3 col-md-2">
                <b-button class="finish-button" variant="success" @click="concluir">
                    Concluir
                    <i class="fas fa-flag-checkered"></i>
                </b-button>
            </div>
        </div>
        <div class="mx-auto">
            <b-row>
                <b-col sm="12" md="12">
                    <b-list-group>
                        <b-list-group-item class="flex-column align-items-start">
                            <div class="d-flex w-100 justify-content-between">
                                <h3 class="app-title mb-1">Requisição Criada</h3>
                            </div>
                            <ul>
                                <li v-if="comunicacaoTransferencia.titularReceita == 0">
                                    Requisição <b>{{codigoReceita}}</b> gerada com sucesso e aguardando validação pelo Tesoureiro do FEPGE e pelo GOFS.
                                </li>
                                <li v-if="comunicacaoTransferencia.titularReceita == 1">
                                    Requisição <b>{{codigoReceita}}</b> criada com sucesso e encaminhada à CES.
                                </li>
                            </ul>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['codigoReceita', 'comunicacaoTransferencia'],
        methods: {
            concluir() {
                this.$router.push({path: '/honorarios'});
            },
        },
    }
</script>
<style>
</style>
